import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { CanActivateChildFn, Router } from '@angular/router';
import { AppStore } from '@aaa/emember/store-types';
import { getAutoRenew } from '@aaa/emember/store-account';
import { Pages } from '../../../constants/pages';

export const checkPermissionForAdd: CanActivateChildFn = () => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);

  return store.select(getAutoRenew).pipe(
    map((autoRenew) => {
      if (autoRenew === true) {
        router.navigateByUrl(Pages.accountMembershipAutoRenewView);

        return false;
      }

      return true;
    }),
  );
};

export default checkPermissionForAdd;
